import React from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import SectionWiseClassification from "../SectionWiseClassification";
import { useAppDispatch, useAppSelector } from "../redux/hooks/redux-hooks";
import { useEffect } from "react";
import Loader from "./loader/Loader";
import { appConfig } from "../utility/config";
import { logOutUser, validateLoggedInUser } from "../redux/actions/UserActions";
import { getStorageValue } from "../utility/utils";
import { loginRequest } from "../authConfig";
import { InteractionStatus } from "@azure/msal-browser";

const HomePage = () => {
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  const dispatch = useAppDispatch();
  const displayToast = useAppSelector((state) => state.toast.displayToast);

  const isLoggedIn = useAppSelector(
    (state) => state.user.loggedIn_User.loggedIn
  );

  const isUserFetching = useAppSelector((state) => state.user.isFetching);

  const activeAccount = instance.getActiveAccount();

  useEffect(() => {
    if (
      !isAuthenticated &&
      !activeAccount &&
      inProgress !== InteractionStatus.Startup &&
      inProgress !== InteractionStatus.HandleRedirect
    ) {
      instance.loginRedirect(loginRequest);
    }
  }, [isAuthenticated, inProgress, instance, activeAccount]);

  // To call the validate login user details and store it in storage when login user exists
  useEffect(() => {
    const validateLoginUser = async () => {
      const loginUserDetails = getStorageValue(appConfig.loginUserStorageKey);

      const logOutUserHandler = () => {
        displayToast("Invalid Email or Password", "error");
        dispatch(logOutUser());
        instance.logoutRedirect();
      };

      if (!loginUserDetails && !isUserFetching && activeAccount) {
        try {
          const response: any = await dispatch(
            validateLoggedInUser(
              activeAccount.username,
              appConfig.loginPassword
            )
          );
          if (!response?.loggedIn) {
            logOutUserHandler();
          }
        } catch (error) {
          logOutUserHandler();
        }
      }
    };

    validateLoginUser();
  }, [activeAccount, isUserFetching, dispatch, displayToast, instance]);

  return (
    <>
      {isLoggedIn ? (
        <SectionWiseClassification />
      ) : isUserFetching ? (
        <Loader />
      ) : (
        <></>
      )}
    </>
  );
};

export default HomePage;
